import React, { useState, useEffect } from 'react';
import { FiEdit2, FiTrash2, FiEye, FiLogOut, FiCalendar, FiUsers, FiHome, FiX, FiCheck, FiClock, FiDollarSign, FiUser, FiCheckCircle, FiFileText, FiCreditCard, FiMapPin } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { handlePrintBill, generateBillHTML } from '../../utils/billUtils';
import { TbCurrencyRupee } from 'react-icons/tb';
import EditBookingModal from '../../components/EditBookingModal';

const statusStyles = {
  checked_in: "bg-green-500/20 text-black-100 border border-green-400/30",
  checked_out: "bg-blue-500/20 text-black-100 border border-blue-400/30",
  booked: "bg-yellow-500/20 text-black-100 border border-yellow-400/30",
  cancelled: "bg-red-500/20 text-black-100 border border-red-400/30"
};

const CheckinManagement = () => {
  const [checkins, setCheckins] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [floors, setFloors] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState('');
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('all');
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCancelBookingModal, setShowCancelBookingModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCheckin, setSelectedCheckin] = useState(null);
  const [cancelBookingData, setCancelBookingData] = useState({
    remark: '',
    refundableAmount: 0
  });
  
  // State for dynamic GST calculation
  const [dynamicGst, setDynamicGst] = useState(0);
  const [dynamicFinalAmount, setDynamicFinalAmount] = useState(0);
  const [dynamicPaidAmount, setDynamicPaidAmount] = useState(0);
  const [dynamicOtherAmount, setDynamicOtherAmount] = useState('');
  const [dynamicOtherAmountRemark, setDynamicOtherAmountRemark] = useState('');
  const [settledAmount, setSettledAmount] = useState(0);
  const [tipAmount, setTipAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [loadingGstSettings, setLoadingGstSettings] = useState(false);
  const [isGstInclude, setIsGstInclude] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [customerGstNumber, setCustomerGstNumber] = useState('');

  const [paymentAmountByApi,setPaymentAmountByApi] = useState({})
  const [finalPendingAmount,setFinalPendingAmount] = useState(0)
  
  // State for calculated values
  const [calculatedBase, setCalculatedBase] = useState(0);
  const [calculatedGstAmount, setCalculatedGstAmount] = useState(0);
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [calculatedDue, setCalculatedDue] = useState(0);


  useEffect(()=>{
    const isEmpty = Object.keys(paymentAmountByApi || {}).length === 0;
    if (isEmpty) return; // ✅ just stop execution

    let pendingAmount = paymentAmountByApi.totalRoomAmount - paymentAmountByApi.paidAmount + Number(dynamicOtherAmount);
    let diffAmount = pendingAmount - settledAmount;

    console.log(pendingAmount,"pendingAmount-22",diffAmount,settledAmount);
    
    if(pendingAmount > settledAmount){
      let roomBaseAmount = paymentAmountByApi.roomBaseAmount-((diffAmount*100)/(100+dynamicGst));
      roomBaseAmount =  Math.round(Number(roomBaseAmount.toFixed(2))); // 10
      let parsedGstAmount = Math.round((roomBaseAmount * dynamicGst) / 100);
      let totalAmount = roomBaseAmount + parsedGstAmount;
      let dueBalance = totalAmount - dynamicPaidAmount + Number(dynamicOtherAmount);
      let pendingAmount = roomBaseAmount + parsedGstAmount + Number(dynamicOtherAmount) + diffAmount - paymentAmountByApi.paidAmount;
      setCalculatedTotal(totalAmount);
      setCalculatedBase(roomBaseAmount);
      setCalculatedGstAmount(parsedGstAmount);
      setCalculatedDue(dueBalance);
      setDiscountAmount(diffAmount);
      setFinalPendingAmount(pendingAmount);
      setTipAmount(0);
    }else{
      let roomBaseAmount = paymentAmountByApi.roomBaseAmount;
      let totalAmount = paymentAmountByApi.totalRoomAmount;
      const dueBalance = paymentAmountByApi.totalRoomAmount - paymentAmountByApi.paidAmount + Math.abs(diffAmount) + Number(dynamicOtherAmount);
      let pendingAmount = paymentAmountByApi.totalRoomAmount + Number(dynamicOtherAmount) - paymentAmountByApi.paidAmount;
      setCalculatedTotal(totalAmount);
      setCalculatedBase(roomBaseAmount);
      setCalculatedGstAmount(paymentAmountByApi.gstAmount);
      setCalculatedDue(dueBalance);
      setDiscountAmount(0);
      setTipAmount(Math.abs(diffAmount));
      setFinalPendingAmount(pendingAmount);
    }
    
  },[settledAmount,dynamicOtherAmount,paymentAmountByApi])

  useEffect(()=>{
    let roomBaseAmount = paymentAmountByApi.roomBaseAmount;
    let gstAmount = (roomBaseAmount * dynamicGst) / 100;
    let totalRoomAmount = roomBaseAmount + gstAmount;
    setPaymentAmountByApi((old)=>{
      return {
        ...old,
        gstAmount,
        totalRoomAmount
      }
    })
  },[dynamicGst])

  // Initialize dynamic values when modal opens
  const initializeCheckoutModal = async (checkin) => {
    setSelectedCheckin(checkin);
    setLoadingGstSettings(true);

    // Fetch current GST settings
    try {
      const response = await api.get('/vendor/room-management/settings');
      const currentGst = response.data.settings.gstPercentage;
      const gstInclude = response.data.settings.isGstInclude || false;
      const dueBalance = checkin.pricing.finalRoomAmount - checkin.pricing.paidAmount;

      setCalculatedBase(checkin.pricing.roomBaseAmount);
      setCalculatedGstAmount(checkin.pricing.gstAmount);
      setCalculatedTotal(checkin.pricing.finalRoomAmount);
      setDynamicPaidAmount(checkin.pricing.paidAmount)
      setCalculatedDue(dueBalance);
      setDynamicGst(currentGst);
      setIsGstInclude(gstInclude);
      setDynamicFinalAmount(parseFloat(checkin.pricing.initialRoomAmount.toFixed(2)));
      setFinalPendingAmount(dueBalance);
      setSettledAmount(dueBalance);
       setPaymentAmountByApi({
        gstAmount: checkin.pricing.gstAmount,
        totalRoomAmount: checkin.pricing.totalFinalAmount,//Gst Amount + RoomBase Amount
        paidAmount: checkin.pricing.paidAmount,
        roomBaseAmount: checkin.pricing.roomBaseAmount,
      })

      // Show modal after all values are set
      setShowCheckoutModal(true);
    } catch (error) {
      console.error('Error fetching GST settings:', error);
      setShowCheckoutModal(true);
    } finally {
      setLoadingGstSettings(false);
    }
  };

  // Calculate dynamic totals

  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCheckins, setTotalCheckins] = useState(0);
  const itemsPerPage = 10;
  
  // Current occupants pagination states
  const [currentOccupantsPage, setCurrentOccupantsPage] = useState(1);
  const [currentOccupantsTotalPages, setCurrentOccupantsTotalPages] = useState(1);
  const [currentOccupantsTotal, setCurrentOccupantsTotal] = useState(0);
  const currentOccupantsItemsPerPage = 10;
  
  // Filter states
  const [filters, setFilters] = useState({
    status: '',
    roomId: '',
    floorId: '',
    startDate: '',
    endDate: '',
    searchQuery: ''
  });
  
  // Debounce state for search
  const [searchInput, setSearchInput] = useState('');
  const [searchTimeout, setSearchTimeout] = useState(null);
  
  const [showFilters, setShowFilters] = useState(true);
  
  const [formData, setFormData] = useState({
    roomId: '',
    expectedCheckoutDateTime: '',
    totalAmount: '',
    paidAmount: '',
    paymentStatus: 'pending',
    specialRequests: '',
    notes: '',
    persons: [{ name: '', mobileNumber: '', identityNumber: '', email: '', address: '', age: '', gender: 'male' }]
  });

  useEffect(() => {
    if (activeTab === 'all') {
      fetchAllCheckins();
    } else {
      fetchData();
    }
  }, [activeTab, currentPage, filters, currentOccupantsPage,showEditModal]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  const fetchData = async () => {
    try {
      setLoading(true);
      let endpoint, params;
      
      if (activeTab === 'current') {
        endpoint = '/vendor/checkin-management/occupants';
        params = new URLSearchParams();
        params.append('page', currentOccupantsPage);
        params.append('limit', currentOccupantsItemsPerPage);
        
        endpoint += `?${params.toString()}`;
      } else if (activeTab === 'booked') {
        endpoint = '/vendor/checkin-management/checkins';
        params = new URLSearchParams();
        params.append('page', currentPage);
        params.append('limit', itemsPerPage);
        params.append('status', 'booked');
        
        // Add filters
        if (filters.roomId) params.append('roomId', filters.roomId);
        if (filters.floorId) params.append('floorId', filters.floorId);
        if (filters.startDate) params.append('startDate', filters.startDate);
        if (filters.endDate) params.append('endDate', filters.endDate);
        if (filters.searchQuery) params.append('search', filters.searchQuery);
        
        endpoint += `?${params.toString()}`;
      } else {
        endpoint = '/vendor/checkin-management/checkins';
        params = new URLSearchParams();
        params.append('page', currentPage);
        params.append('limit', itemsPerPage);
        
        // Add filters
        if (filters.status) params.append('status', filters.status);
        if (filters.roomId) params.append('roomId', filters.roomId);
        if (filters.floorId) params.append('floorId', filters.floorId);
        if (filters.startDate) params.append('startDate', filters.startDate);
        if (filters.endDate) params.append('endDate', filters.endDate);
        if (filters.searchQuery) params.append('search', filters.searchQuery);
        
        endpoint += `?${params.toString()}`;
      }
      
      const [checkinsResponse, roomsResponse, floorsResponse] = await Promise.all([
        api.get(endpoint),
        api.get('/vendor/room-management/rooms?isPaginate=false'),
        api.get('/vendor/room-management/floors')
      ]);

      if (activeTab === 'current') {
        let checkInData = checkinsResponse.data.occupants;
        checkInData.sort((a, b) => new Date(b.checkinDate) - new Date(a.checkinDate));
        setCheckins(checkInData);
        // Set pagination info for current occupants
        if (checkinsResponse.data.pagination) {
          setCurrentOccupantsTotalPages(checkinsResponse.data.pagination.totalPages);
          setCurrentOccupantsTotal(checkinsResponse.data.pagination.total);
        } else {
          setCurrentOccupantsTotalPages(1);
          setCurrentOccupantsTotal(checkinsResponse.data.length);
        }
      } else if (activeTab === 'booked') {
        let checkInData = checkinsResponse.data.checkins;
        checkInData.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        setCheckins(checkInData);
        
        // Set pagination info for booked
        if (checkinsResponse.data.pagination) {
          setTotalPages(checkinsResponse.data.pagination.totalPages);
          setTotalCheckins(checkinsResponse.data.pagination.total);
        }
      } else {
        setCheckins(checkinsResponse.data.checkins || checkinsResponse.data);
        
        // Set pagination info for all check-ins
        if (checkinsResponse.data.pagination) {
          setTotalPages(checkinsResponse.data.pagination.totalPages);
          setTotalCheckins(checkinsResponse.data.pagination.total);
        } else {
          setTotalPages(1);
          setTotalCheckins(checkinsResponse.data.length);
        }
      }
      
      const allRooms = roomsResponse.data.rooms || roomsResponse.data;
      setRooms(allRooms);
      setFilteredRooms(allRooms); 
      setFloors(floorsResponse.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  const fetchAllCheckins = async () => {
    try {
      setLoading(true);
      
      // Build query params for filters and pagination
      const params = new URLSearchParams();
      params.append('page', currentPage);
      params.append('limit', itemsPerPage);
      
      // Add filters
      if (filters.status) params.append('status', filters.status);
      if (filters.roomId) params.append('roomId', filters.roomId);
      if (filters.floorId) params.append('floorId', filters.floorId);
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.searchQuery) params.append('search', filters.searchQuery);
      
      const [checkinsResponse, roomsResponse, floorsResponse] = await Promise.all([
        api.get(`/vendor/checkin-management/checkins?${params.toString()}`),
        api.get('/vendor/room-management/rooms?isPaginate=false'),
        api.get('/vendor/room-management/floors')
      ]);
      
      setCheckins(checkinsResponse.data.checkins || checkinsResponse.data);
      const allRooms = roomsResponse.data.rooms || roomsResponse.data;
      setRooms(allRooms);
      setFilteredRooms(allRooms.filter(room => room.status === 'available'));
      setFloors(floorsResponse.data);
      
      // Set pagination info
      if (checkinsResponse.data.pagination) {
        setTotalPages(checkinsResponse.data.pagination.totalPages);
        setTotalCheckins(checkinsResponse.data.pagination.total);
      } else {
        setTotalPages(1);
        setTotalCheckins(checkinsResponse.data.length);
      }
    } catch (error) {
      console.error('Error fetching all checkins:', error);
      toast.error('Failed to fetch checkins');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    if (key === 'searchQuery') {
      // Handle search with debouncing
      setSearchInput(value);
      
      // Clear existing timeout
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
      
      // Set new timeout for 1 second
      const timeout = setTimeout(() => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setCurrentPage(1); // Reset to first page when filters change
      }, 1000);
      
      setSearchTimeout(timeout);
    } else {
      // Handle other filters immediately
      setFilters(prev => ({ ...prev, [key]: value }));
      setCurrentPage(1); // Reset to first page when filters change
    }
  };

  const clearFilters = () => {
    // Clear timeout if exists
    if (searchTimeout) {
      clearTimeout(searchTimeout);
      setSearchTimeout(null);
    }
    
    setFilters({
      status: '',
      roomId: '',
      floorId: '',
      startDate: '',
      endDate: '',
      searchQuery: ''
    });
    setSearchInput('');
    setCurrentPage(1);
  };

  // Quick date filter functions
  const setTodayFilter = () => {
    const today = new Date().toLocaleDateString('en-CA');
    setFilters(prev => ({
      ...prev,
      startDate: today,
      endDate: today
    }));
    setCurrentPage(1);
  };

  const setYesterdayFilter = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayString = yesterday.toLocaleDateString('en-CA');
    setFilters(prev => ({
      ...prev,
      startDate: yesterdayString,
      endDate: yesterdayString
    }));
    setCurrentPage(1);
  };

  // Helper function to get date label for filter display
  const getFilterDateLabel = (dateString) => {
    const today = new Date().toLocaleDateString('en-CA');
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayString = yesterday.toLocaleDateString('en-CA');
    
    if (dateString === today) {
      return 'Today';
    } else if (dateString === yesterdayString) {
      return 'Yesterday';
    } else {
      return new Date(dateString).toLocaleDateString();
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleCurrentOccupantsPageChange = (page) => {
    setCurrentOccupantsPage(page);
  };


  
  const handleCheckout = async () => {
    if (!selectedCheckin) return;

    try {
      const requestData = {
        actualCheckoutDateTime: new Date().toISOString(),
        gstPercentage: dynamicGst,
        finalAmount: dynamicFinalAmount,
        finalPendingAmount: finalPendingAmount,
        settledAmount: settledAmount,
        tipAmount: tipAmount,
        discountAmount: discountAmount,
        otherAmount: dynamicOtherAmount,
        otherAmountRemark: dynamicOtherAmountRemark,
        isGstInlude: isGstInclude,
        gstAmount: calculatedGstAmount,
        paymentMethod: paymentMethod,
        customerGstNumber: customerGstNumber
      };

      await api.post(`/vendor/checkin-management/checkout/${selectedCheckin.checkinId}`, requestData);

      toast.success('Check-out successful');
      setShowCheckoutModal(false);
      
      // Auto-generate bill after successful checkout
      setTimeout(() => {
        handlePrintBill(selectedCheckin.checkinId);
      }, 1000);
      
      setSelectedCheckin(null);
      fetchData();
    } catch (error) {
      console.error('Error during checkout:', error);
      toast.error(error.response?.data?.message || 'Failed to check out');
    }
  };

  const handleViewDetails = (checkin) => {
    setSelectedCheckin(checkin);
    setShowDetailsModal(true);
  };

  const handlePerformCheckin = async (checkin) => {
    try {
      // Use checkinId (custom ID) instead of _id (MongoDB ID)
      const response = await api.put(`/vendor/checkin-management/checkins/${checkin.checkinId}`, {
        status: 'checked_in',
        actualCheckinDateTime: new Date()
      });
      
      if (response.data) {
        toast.success('Guest checked in successfully!');
        fetchData(); // Refresh the data
      }
    } catch (error) {
      console.error('Error checking in guest:', error);
      toast.error('Failed to check in guest');
    }
  };

  const handleCancelBooking = (checkin) => {
    setSelectedCheckin(checkin);
    // Set default refundable amount to 0 (user will decide)
    setCancelBookingData({
      remark: '',
      refundableAmount: 0
    });
    setShowCancelBookingModal(true);
  };

  const handleEditBooking = (checkin) => {
    setSelectedCheckin(checkin);
    setShowEditModal(true);
  };

  const confirmCancelBooking = async () => {
    try {
      // Use checkinId (custom ID) instead of _id (MongoDB ID)
      const response = await api.post(`/vendor/checkin-management/checkins/${selectedCheckin.checkinId}/cancel`, {
        remark: cancelBookingData.remark,
        refundableAmount: cancelBookingData.refundableAmount
      });
      
      if (response.data) {
        toast.success('Booking cancelled successfully!');
        setShowCancelBookingModal(false);
        setCancelBookingData({ remark: '', refundableAmount: 0 });
        setSelectedCheckin(null);
        fetchData(); // Refresh the data
      }
    } catch (error) {
      console.error('Error cancelling booking:', error);
      toast.error('Failed to cancel booking');
    }
  };

  const addPerson = () => {
    setFormData({
      ...formData,
      persons: [...formData.persons, { name: '', mobileNumber: '', identityNumber: '', email: '', address: '', age: '', gender: 'male' }]
    });
  };

  const removePerson = (index) => {
    if (formData.persons.length > 1) {
      setFormData({
        ...formData,
        persons: formData.persons.filter((_, i) => i !== index)
      });
    }
  };

  const updatePerson = (index, field, value) => {
    const updatedPersons = [...formData.persons];
    updatedPersons[index][field] = value;
    setFormData({ ...formData, persons: updatedPersons });
  };

  const resetForm = () => {
    setFormData({
      roomId: '',
      expectedCheckoutDateTime: '',
      totalAmount: '',
      paidAmount: '',
      paymentStatus: 'pending',
      specialRequests: '',
      notes: '',
      persons: [{ name: '', mobileNumber: '', identityNumber: '', email: '', address: '', age: '', gender: 'male' }]
    });
    setSelectedFloor('');
    setFilteredRooms(rooms.filter(room => room.status === 'available'));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'checked_in': return 'bg-green-100 text-green-800';
      case 'checked_out': return 'bg-gray-100 text-gray-800';
      case 'cancelled': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div>
      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab('all')}
            className={`py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'all'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            All List
          </button>
          <button
            onClick={() => setActiveTab('current')}
            className={`py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'current'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            CheckIn List
          </button>
          <button
            onClick={() => setActiveTab('booked')}
            className={`py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'booked'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Booking List
          </button>
          
        </nav>
      </div>

      {activeTab === 'current' && currentOccupantsTotalPages > 1 && (
        <div className="bg-white rounded-lg shadow px-6 py-4 mt-6">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-700">
              Showing {((currentOccupantsPage - 1) * currentOccupantsItemsPerPage) + 1} to {Math.min(currentOccupantsPage * currentOccupantsItemsPerPage, currentOccupantsTotal)} of {currentOccupantsTotal} current occupants
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => handleCurrentOccupantsPageChange(currentOccupantsPage - 1)}
                disabled={currentOccupantsPage === 1}
                className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Previous
              </button>
              
              {/* Page Numbers */}
              <div className="flex items-center space-x-1">
                {Array.from({ length: Math.min(5, currentOccupantsTotalPages) }, (_, i) => {
                  let pageNum;
                  if (currentOccupantsTotalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentOccupantsPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentOccupantsPage >= currentOccupantsTotalPages - 2) {
                    pageNum = currentOccupantsTotalPages - 4 + i;
                  } else {
                    pageNum = currentOccupantsPage - 2 + i;
                  }
                  
                  return (
                    <button
                      key={pageNum}
                      onClick={() => handleCurrentOccupantsPageChange(pageNum)}
                      className={`px-3 py-2 text-sm font-medium rounded-lg ${
                        currentOccupantsPage === pageNum
                          ? 'bg-blue-600 text-white'
                          : 'text-gray-500 bg-white border border-gray-300 hover:bg-gray-50'
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </div>
              
              <button
                onClick={() => handleCurrentOccupantsPageChange(currentOccupantsPage + 1)}
                disabled={currentOccupantsPage === currentOccupantsTotalPages}
                className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Filters Section - Only show for All Check-ins */}
      {activeTab === 'all' && (
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="px-6 py-4 border-b border-gray-200">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
              <div className="flex space-x-2">
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  className="px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors"
                >
                  {showFilters ? 'Hide Filters' : 'Show Filters'}
                </button>
                <button
                  onClick={clearFilters}
                  className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Clear All
                </button>
              </div>
            </div>
          </div>
          
          {showFilters && (
            <div className="px-6 py-4 border-b border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {/* Search */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Search</label>
                  <input
                    type="text"
                    value={searchInput}
                    onChange={(e) => handleFilterChange('searchQuery', e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();
                        // Trigger immediate search on Enter
                        if (searchTimeout) {
                          clearTimeout(searchTimeout);
                        }
                        setFilters(prev => ({ ...prev, searchQuery: searchInput }));
                        setCurrentPage(1);
                      }
                    }}
                    placeholder="Search by name, mobile, check-in ID..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                
                {/* Floor Filter */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Floor</label>
                  <select
                    value={filters.floorId}
                    onChange={(e) => handleFilterChange('floorId', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">All Floors</option>
                    {floors.map((floor) => (
                      <option key={floor._id} value={floor._id}>{floor.name}</option>
                    ))}
                  </select>
                </div>
                
                {/* Room Filter */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Room</label>
                  <select
                    value={filters.roomId}
                    onChange={(e) => handleFilterChange('roomId', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">All Rooms</option>
                    {rooms
                      .filter(room => !filters.floorId || room.floorId?._id === filters.floorId)
                      .map((room) => (
                        <option key={room._id} value={room._id}>{room.roomNumber}</option>
                      ))}
                  </select>
                </div>
                
                {/* Quick Date Filters */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Quick Date Filter</label>
                  <div className="flex gap-2">
                    <button
                      onClick={setTodayFilter}
                      className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                        filters.startDate === new Date().toLocaleDateString('en-CA')
                          ? 'bg-blue-600 text-white'
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    >
                      Today
                    </button>
                    <button
                      onClick={setYesterdayFilter}
                      className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                        (() => {
                          const yesterday = new Date();
                          yesterday.setDate(yesterday.getDate() - 1);
                          return filters.startDate === yesterday.toLocaleDateString('en-CA');
                        })()
                          ? 'bg-gray-600 text-white'
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    >
                      Yesterday
                    </button>
                  </div>
                </div>

                {/* Custom Date Filter */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Custom Date</label>
                  <input
                    type="date"
                    value={filters.startDate}
                    onChange={(e) => handleFilterChange('startDate', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                {/* Status Filter */}
                {
                  activeTab === 'all' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                      <select
                        value={filters.status}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="">All Status</option>
                        <option value="checked_in">Checked In</option>
                        <option value="checked_out">Checked Out</option>
                        <option value="booked">Booked</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </div>
                  )
                }
              </div>
            </div>
          )}
          
          {/* Active Filters Display */}
          <div className="px-6 py-3">
            <div className="flex flex-wrap gap-2">
              {filters.searchQuery && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  Search: {filters.searchQuery}
                  <button
                    onClick={() => handleFilterChange('searchQuery', '')}
                    className="ml-2 text-blue-600 hover:text-blue-800"
                  >
                    ×
                  </button>
                </span>
              )}
              {filters.status && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  Status: {filters.status.replace('_', ' ')}
                  <button
                    onClick={() => handleFilterChange('status', '')}
                    className="ml-2 text-green-600 hover:text-green-800"
                  >
                    ×
                  </button>
                </span>
              )}
              {filters.floorId && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                  Floor: {floors.find(f => f._id === filters.floorId)?.name}
                  <button
                    onClick={() => handleFilterChange('floorId', '')}
                    className="ml-2 text-purple-600 hover:text-purple-800"
                  >
                    ×
                  </button>
                </span>
              )}
              {filters.roomId && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                  Room: {rooms.find(r => r._id === filters.roomId)?.roomNumber}
                  <button
                    onClick={() => handleFilterChange('roomId', '')}
                    className="ml-2 text-orange-600 hover:text-orange-800"
                  >
                    ×
                  </button>
                </span>
              )}
              {filters.startDate && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                  Date: {getFilterDateLabel(filters.startDate)}
                  <button
                    onClick={() => handleFilterChange('startDate', '')}
                    className="ml-2 text-indigo-600 hover:text-indigo-800"
                  >
                    ×
                  </button>
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Check-ins List */}
      <div className="bg-white rounded-lg shadow">
        {checkins.length === 0 ? (
          <div className="p-8 text-center">
            <FiUser className="mx-auto text-4xl text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              {activeTab === 'current' ? 'No current occupants' : 'No check-ins found'}
            </h3>
            <p className="text-gray-500 mb-4">
              {activeTab === 'current' ? 'No guests currently checked in' : 'No check-in records found'}
            </p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Check-in ID
                  </th>
                  {activeTab === 'booked' && (
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Booking Date
                    </th>
                  )}
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Guests
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Room
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Check-in Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Expected Checkout
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Amount
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {checkins.map((checkin) => (
                  <tr key={checkin._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm font-medium text-gray-900">
                        {checkin.checkinId || 'N/A'}
                      </span>
                    </td>
                    {activeTab === 'booked' && (
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {new Date(checkin.bookingDate || checkin.createdAt).toLocaleDateString('en-IN', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })}
                        </div>
                        <div className="text-sm text-gray-500">
                          {new Date(checkin.bookingDate || checkin.createdAt).toLocaleTimeString('en-IN', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })}
                        </div>
                      </td>
                    )}
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {checkin.persons?.map((person, index) => (
                          <div key={index} className="flex flex-col">
                            {person.name}
                          </div>
                        ))}
                      </div>
                      <div className="text-sm text-gray-500">{checkin.persons?.[0]?.mobileNumber}</div>
                      <div className="mt-1">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(checkin.status)}`}>
                          {checkin.status.replace('_', ' ')}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{checkin.roomId?.roomNumber}</div>
                      <div className="text-sm text-gray-500">{checkin.floorId?.name}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {checkin.status === 'booked' ? (
                          <div>
                            <span className="text-yellow-600 font-medium">Expected Check-in</span>
                            <div className="text-xs text-gray-600 mt-1">
                              {new Date(checkin.checkinDateTime).toLocaleDateString('en-IN', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                              })}
                            </div>
                          </div>
                        ) : (
                          <>
                            {new Date(checkin.checkinDateTime).toLocaleDateString('en-IN', {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric'
                            })}
                          </>
                        )}
                      </div>
                      <div className="text-sm text-gray-500">
                        {checkin.status === 'booked' ? (
                          <span className="text-xs">{new Date(checkin.checkinDateTime).toLocaleTimeString('en-IN', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })}</span>
                        ) : (
                          <>
                            {checkin.checkinTime || new Date(checkin.checkinDateTime).toLocaleTimeString('en-IN', {
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            })}
                          </>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {new Date(checkin.expectedCheckoutDateTime).toLocaleDateString('en-IN', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </div>
                      <div className="text-sm text-gray-500">
                        {checkin.expectedCheckoutTime || new Date(checkin.expectedCheckoutDateTime).toLocaleTimeString('en-IN', {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true
                        })}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">₹{checkin.pricing.finalRoomAmount}</div>
                      <div className="text-sm text-gray-500">Paid: ₹{checkin.pricing.finalPaidAmount}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex flex-col space-y-2">
                        <button
                          onClick={() => handleViewDetails(checkin)}
                          className="px-3 py-1 text-xs font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded hover:bg-blue-100 transition-colors"
                        >
                          View Details
                        </button>
                        {checkin.status === 'booked' && (
                          <>
                            <button
                              onClick={() => handlePerformCheckin(checkin)}
                              className="px-3 py-1 text-xs font-medium text-green-600 bg-green-50 border border-green-200 rounded hover:bg-green-100 transition-colors"
                            >
                              Check-in
                            </button>
                            <button
                              onClick={() => handleEditBooking(checkin)}
                              className="px-3 py-1 text-xs font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded hover:bg-blue-100 transition-colors"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleCancelBooking(checkin)}
                              className="px-3 py-1 text-xs font-medium text-red-600 bg-red-50 border border-red-200 rounded hover:bg-red-100 transition-colors"
                            >
                              Cancel Booking
                            </button>
                          </>
                        )}
                        {checkin.status === 'checked_in' && (
                          <>
                            <button
                              onClick={() => handleEditBooking(checkin)}
                              className="px-3 py-1 text-xs font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded hover:bg-blue-100 transition-colors"
                            >
                              Edit
                            </button>
                          </>
                        )}
                        {checkin.status === 'checked_in' && (
                          <button
                            onClick={() => initializeCheckoutModal(checkin)}
                            className="px-3 py-1 text-xs font-medium text-red-600 bg-red-50 border border-red-200 rounded hover:bg-red-100 transition-colors"
                          >
                            Check-out
                          </button>
                        )}
                        {checkin.status === 'checked_out' && (
                          <button
                            onClick={() => handlePrintBill(checkin.checkinId)}
                            className="px-3 py-1 text-xs font-medium text-green-600 bg-green-50 border border-green-200 rounded hover:bg-green-100 transition-colors"
                          >
                            Generate Bill
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Pagination - Only show for All Check-ins */}
      {activeTab === 'all' && totalPages > 1 && (
        <div className="bg-white rounded-lg shadow px-6 py-4 mt-6">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-700">
              Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalCheckins)} of {totalCheckins} results
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Previous
              </button>
              
              {/* Page Numbers */}
              <div className="flex items-center space-x-1">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }
                  
                  return (
                    <button
                      key={pageNum}
                      onClick={() => handlePageChange(pageNum)}
                      className={`px-3 py-2 text-sm font-medium rounded-lg ${
                        currentPage === pageNum
                          ? 'bg-blue-600 text-white'
                          : 'text-gray-500 bg-white border border-gray-300 hover:bg-gray-50'
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </div>
              
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Checkout Confirmation Modal */}
      {showCheckoutModal && selectedCheckin && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-10 mx-auto border w-[500px] shadow-2xl rounded-xl bg-white flex flex-col max-h-[80vh]">
            {/* Header */}
            <div className="flex items-center justify-between p-6 pb-4 border-b border-gray-200 flex-shrink-0">
              <h3 className="text-xl font-bold text-gray-900">Guest Check-out</h3>
              <button
                onClick={() => {
                  setShowCheckoutModal(false);
                  setSelectedCheckin(null);
                }}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <FiX className="text-xl text-gray-500" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-6">
              {/* Guest Information */}
              <div className="mb-6">
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-1">
                        {selectedCheckin.persons?.[0]?.name}
                      </h4>
                      <div className="space-y-1">
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Room:</span> {selectedCheckin.roomId?.roomNumber}
                        </p>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Check-in ID:</span> {selectedCheckin.checkinId}
                        </p>
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                        <FiUser className="text-2xl text-blue-600" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Payment Details with GST */}
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                  <TbCurrencyRupee className="mr-2 text-green-600" />
                  Payment Breakdown
                </h4>
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <div className="space-y-3">
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">Base Amount:</span>
                      <span className="text-sm font-bold text-gray-900">₹{calculatedBase.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">GST ({dynamicGst}%):</span>
                      <span className="text-sm font-bold text-blue-600">+ ₹{calculatedGstAmount.toFixed(2)}</span>
                    </div>
                   
                    <div className="border-t pt-3">
                      <div className="flex justify-between items-center">
                        <span className="text-base font-semibold text-gray-800">
                          Total Amount:
                        </span>

                        <div className="text-right">
                          {/* Original Price */}
                          {discountAmount > 0 && (
                            <div className="text-sm text-gray-500 line-through">
                              ₹{paymentAmountByApi?.totalRoomAmount?.toFixed(2)}
                            </div>
                          )}

                          {/* Discount Amount (Red) */}
                          {discountAmount > 0 && (
                            <div className="text-sm font-medium text-red-500">
                              - ₹{discountAmount.toFixed(2)}
                            </div>
                          )}

                          {/* Final Price */}
                          <div className="text-base font-bold text-green-600">
                            = ₹{calculatedTotal.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                     {dynamicOtherAmount > 0 && (
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">Other Amount:</span>
                        <span className="text-sm font-bold text-purple-600">+ ₹{dynamicOtherAmount}</span>
                      </div>
                    )}
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">Paid Amount:</span>
                      <span className="text-sm font-bold text-green-600">- ₹{(dynamicPaidAmount || selectedCheckin.pricing.paidAmount || 0).toFixed(2)}</span>
                    </div>
                    {
                      tipAmount > 0 && 
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">Tip Amount:</span>
                        <span className="text-sm font-bold text-green-600">+ ₹{tipAmount}</span>
                      </div>
                    }
                    <div className="border-t pt-3">
                      <div className="flex justify-between items-center">
                        <span className="text-base font-semibold text-gray-800">Due Balance:</span>
                        <span className={`text-base font-bold ${
                          calculatedDue > 0
                            ? 'text-red-600'
                            : 'text-green-600'
                        }`}>
                          = ₹{calculatedDue.toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center pt-2">
                      <span className="text-sm text-gray-600">Payment Status:</span>
                      <span className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${
                        calculatedDue > 0
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-green-100 text-green-800'
                      }`}>
                        {calculatedDue > 0 ? 'PARTIAL' : 'PAID'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
                
              {/* Final Payment Collection */}
              { (
                <div className="mb-6">
                  <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                    <FiEdit2 className="mr-2 text-orange-600" />
                    Final Payment Details
                  </h4>
                  <form onSubmit={(e) => e.preventDefault()} className="bg-orange-50 rounded-lg p-4 border border-orange-200">
                    <div className="grid grid-cols-1 gap-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          GST Percentage
                        </label>
                        <div className="relative">
                          <input
                            type="text"
                            inputMode="decimal"
                            value={loadingGstSettings ? 'Loading...' : dynamicGst}
                            placeholder="18"
                            disabled={loadingGstSettings}
                            className={`w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 ${
                              loadingGstSettings ? 'bg-gray-100 text-gray-500' : ''
                            }`}
                            id="gstPercentage"
                            onChange={(e) => {
                            const value = e.target.value;
                              // handleGstChange(value);
                              setDynamicGst(Number(value))
                            }}
                          />
                          <span className="absolute right-3 top-2.5 text-gray-500 text-sm">%</span>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Final Room Amount
                        </label>
                        <input
                          type="text"
                          inputMode="decimal"
                          disabled
                          value={dynamicFinalAmount}
                          placeholder={selectedCheckin.pricing.initialRoomAmount}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                          id="finalAmount"
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numbers and up to 2 decimal places
                            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                              setDynamicFinalAmount(value === '' ? 0 : parseFloat(value));
                            }
                          }}
                        />
                      </div>
                      {/* <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Other Amount (Food, etc.)
                        </label>
                        <input
                          type="text"
                          inputMode="decimal"
                          value={dynamicOtherAmount}
                          placeholder="0"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                          id="otherAmount"
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numbers and up to 2 decimal places
                            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                              setDynamicOtherAmount(value);
                            }
                          }}
                        />
                      </div> */}
                      {/* <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Other Amount Remark
                        </label>
                        <textarea
                          value={dynamicOtherAmountRemark}
                          onChange={(e) => setDynamicOtherAmountRemark(e.target.value)}
                          placeholder="Enter details for other charges (food, laundry, etc.)"
                          rows="2"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        />
                      </div> */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Final Pending Amount
                        </label>
                        <input
                          type="text"
                          inputMode="decimal"
                          disabled
                          value={finalPendingAmount}
                          placeholder={selectedCheckin.pricing.paidAmount || 0}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                          id="finalPaidAmount"
                          // onChange={(e) => {
                          //   const value = e.target.value;
                          //   // Allow only numbers and up to 2 decimal places
                          //   if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                          //     setDynamicPaidAmount(value === '' ? 0 : parseFloat(value));
                          //   }
                          // }}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Settled Amount
                        </label>
                        <input
                          type="text"
                          inputMode="decimal"
                          value={settledAmount}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                              setSettledAmount(parseFloat(value) || 0);
                            }
                          }}
                          placeholder="0.00"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        />
                        <p className="text-xs text-gray-500 mt-1">
                          Amount actually settled (can be different from pending amount)
                        </p>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Customer GST Number
                        </label>
                        <input
                          type="text"
                          value={customerGstNumber}
                          onChange={(e) => setCustomerGstNumber(e.target.value.toUpperCase())}
                          placeholder="Enter Customer GST Number"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        <p className="text-xs text-gray-500 mt-1">
                          Enter customer GST number for billing purposes
                        </p>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Tip & Discount Amounts
                        </label>
                        <div className="w-full px-3 py-1.5 border border-gray-200 rounded text-sm bg-gray-50 text-gray-700">
                          <span className="font-semibold text-green-700">Tip: {tipAmount > 0 ? `+${tipAmount.toFixed(2)}` : '0.00'}</span>
                          <span className="mx-4 text-gray-400">|</span>
                          <span className="font-semibold text-orange-700">Discount: {discountAmount > 0 ? `-${discountAmount.toFixed(2)}` : '0.00'}</span>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Payment Method
                        </label>
                        <select
                          value={paymentMethod}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        >
                          <option value="cash">Cash</option>
                          <option value="upi">UPI</option>
                          <option value="card">Card</option>
                        </select>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>

            {/* Fixed Footer */}
            <div className="flex justify-end space-x-3 p-6 pt-4 border-t border-gray-200 bg-white flex-shrink-0">
              <button
                onClick={() => {
                  setShowCheckoutModal(false);
                  setSelectedCheckin(null);
                }}
                className="px-6 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleCheckout}
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center"
              >
                <FiCheckCircle className="mr-2" />
                Check-out Guest
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Details Modal */}
      {showDetailsModal && selectedCheckin && (
        <div className="fixed inset-0 bg-black bg-opacity-60 overflow-y-auto h-full w-full z-50 backdrop-blur-sm">
          <div className="relative top-8 mx-auto p-0 w-full max-w-4xl shadow-2xl rounded-2xl bg-white overflow-hidden">
            {/* Compact Header */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center space-x-4">
                  <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg">
                    <FiFileText className="text-xl text-white" />
                  </div>
                  <div className="text-white">
                    <h3 className="text-xl font-bold">Check-in Details</h3>
                    <p className="text-blue-100 text-sm">ID: {selectedCheckin.checkinId}</p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setShowDetailsModal(false);
                    setSelectedCheckin(null);
                  }}
                  className="bg-white/10 backdrop-blur-sm p-2 rounded-lg hover:bg-white/20 transition-all duration-200"
                >
                  <FiX className="text-xl text-white" />
                </button>
              </div>
            </div>

            <div className="p-6 max-h-[75vh] overflow-y-auto">
              {/* Status Badge */}
              <div className="mb-6">
                <span
                  className={`inline-flex px-4 py-2 text-sm font-semibold rounded-full ${
                    statusStyles[selectedCheckin.status] ||
                    "bg-gray-500/20 text-gray-100 border border-gray-400/30"
                  }`}
                >
                  {selectedCheckin.status.replace('_', ' ').toUpperCase()}
                </span>
              </div>

              {/* Key Info Cards */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-center justify-between mb-2">
                    <FiHome className="text-blue-600 text-lg" />
                    <span className="text-xs font-semibold text-blue-600 uppercase">Room</span>
                  </div>
                  <p className="text-xl font-bold text-gray-900">{selectedCheckin.roomId?.roomNumber}</p>
                  <p className="text-xs text-gray-600">{selectedCheckin.floorId?.name}</p>
                </div>

                <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-4 border border-green-200">
                  <div className="flex items-center justify-between mb-2">
                    <FiCalendar className="text-green-600 text-lg" />
                    <span className="text-xs font-semibold text-green-600 uppercase">
                      {selectedCheckin.status === 'booked' ? 'Expected Check-in' : 'Check-in'}
                    </span>
                  </div>
                  <p className="text-sm font-bold text-gray-900">
                    {new Date(selectedCheckin.checkinDateTime).toLocaleDateString()}
                  </p>
                  <p className="text-xs text-gray-600">
                    {selectedCheckin.status === 'booked' ? (
                      <>
                        Expected Check-in: {new Date(selectedCheckin.checkinDateTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                      </>
                    ) : (
                      new Date(selectedCheckin.checkinDateTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                    )}
                  </p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-4 border border-purple-200">
                  <div className="flex items-center justify-between mb-2">
                    <FiCreditCard className="text-purple-600 text-lg" />
                    <span className="text-xs font-semibold text-purple-600 uppercase">Amount</span>
                  </div>
                  <p className="text-xl font-bold text-gray-900">₹{selectedCheckin.pricing.totalFinalAmount}</p>
                  <p className="text-xs text-gray-600">Total Bill</p>
                </div>

                <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg p-4 border border-orange-200">
                  <div className="flex items-center justify-between mb-2">
                    <FiUsers className="text-orange-600 text-lg" />
                    <span className="text-xs font-semibold text-orange-600 uppercase">Guests</span>
                  </div>
                  <p className="text-xl font-bold text-gray-900">{selectedCheckin.persons?.length || 0}</p>
                  <p className="text-xs text-gray-600">Total Guests</p>
                </div>
              </div>

              {/* Main Content */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Guest Details */}
                <div className="lg:col-span-2">
                  <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                    <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
                      <h4 className="text-base font-semibold text-gray-900 flex items-center">
                        <FiUser className="mr-2 text-blue-600" />
                        Guest Information
                      </h4>
                    </div>
                    <div className="p-4">
                      <div className="space-y-4">
                        {selectedCheckin.persons?.map((person, index) => (
                          <div key={index} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                            <div className="flex justify-between items-start mb-3">
                              <h5 className="text-sm font-bold text-gray-900">Guest {index + 1}</h5>
                              {person.identityImage && (
                                <img 
                                  src={person.identityImage.startsWith('http') ? person.identityImage : `${process.env.REACT_APP_API_URL}${person.identityImage}`}
                                  alt="Identity Card" 
                                  className="w-12 h-10 object-cover rounded cursor-pointer hover:scale-105 transition-transform"
                                  onClick={() => window.open(person.identityImage.startsWith('http') ? person.identityImage : `${process.env.REACT_APP_API_URL}${person.identityImage}`, '_blank')}
                                />
                              )}
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                              <div className="flex items-center space-x-2">
                                <div className="w-6 h-6 bg-blue-100 rounded flex items-center justify-center">
                                  <FiUser className="text-blue-600 text-xs" />
                                </div>
                                <div>
                                  <p className="text-xs text-gray-500">Name</p>
                                  <p className="text-sm font-semibold text-gray-900">{person.name}</p>
                                </div>
                              </div>
                              
                              <div className="flex items-center space-x-2">
                                <div className="w-6 h-6 bg-green-100 rounded flex items-center justify-center">
                                  <FiMapPin className="text-green-600 text-xs" />
                                </div>
                                <div>
                                  <p className="text-xs text-gray-500">Mobile</p>
                                  <p className="text-sm font-semibold text-gray-900">{person.mobileNumber}</p>
                                </div>
                              </div>
                              
                              <div className="flex items-center space-x-2">
                                <div className="w-6 h-6 bg-purple-100 rounded flex items-center justify-center">
                                  <FiCreditCard className="text-purple-600 text-xs" />
                                </div>
                                <div>
                                  <p className="text-xs text-gray-500">Identity</p>
                                  <p className="text-sm font-semibold text-gray-900">{person.identityNumber}</p>
                                </div>
                              </div>
                              
                              {person.email && (
                                <div className="flex items-center space-x-2">
                                  <div className="w-6 h-6 bg-orange-100 rounded flex items-center justify-center">
                                    <FiFileText className="text-orange-600 text-xs" />
                                  </div>
                                  <div>
                                    <p className="text-xs text-gray-500">Email</p>
                                    <p className="text-sm font-semibold text-gray-900">{person.email}</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Sidebar */}
                <div className="space-y-4">
                  {/* Payment */}
                  <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                    <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
                      <h4 className="text-base font-semibold text-gray-900 flex items-center">
                        <FiCreditCard className="mr-2 text-green-600" />
                        Payment
                      </h4>
                    </div>
                    <div className="p-4 space-y-3">
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-600">Room Amount</span>
                        <span className="text-sm font-bold text-gray-900">₹{selectedCheckin.pricing.roomBaseAmount}</span>
                      </div>

                      <div className="flex justify-between">
                        <span className="text-sm text-gray-600">GST</span>
                        <span className="text-sm font-bold text-gray-900">₹{selectedCheckin.pricing.gstAmount}</span>
                      </div>

                      <div className="flex justify-between">
                        <span className="text-sm text-gray-600">Other Amount</span>
                        <span className="text-sm font-bold text-gray-900">₹{selectedCheckin.pricing.otherAmount}</span>
                      </div>

                      <div className="flex justify-between">
                        <span className="text-sm text-gray-600">Tip</span>
                        <span className="text-sm font-bold text-gray-900">₹{selectedCheckin.pricing.tipAmount}</span>
                      </div>

                      <div className="flex justify-between">
                        <span className="text-sm text-gray-600">Discount</span>
                        <span className="text-sm font-bold text-red-600">-₹{selectedCheckin.pricing.discountAmount}</span>
                      </div>

                      <div className="border-t pt-2 flex justify-between">
                        <span className="text-sm text-gray-600">Total</span>
                        <span className="text-sm font-bold text-gray-900">₹{selectedCheckin.pricing.totalFinalAmount}</span>
                      </div>

                      <div className="flex justify-between">
                        <span className="text-sm text-gray-600">Paid</span>
                        <span className="text-sm font-bold text-green-600">₹{selectedCheckin.pricing.finalPaidAmount}</span>
                      </div>

                      <div className="pt-2">
                        <span
                          className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                            selectedCheckin.paymentStatus === 'paid'
                              ? 'bg-green-100 text-green-800'
                              : selectedCheckin.paymentStatus === 'partial'
                              ? 'bg-yellow-100 text-yellow-800'
                              : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {selectedCheckin.paymentStatus.toUpperCase()}
                        </span>
                      </div>

                    </div>
                  </div>

                  {/* Timeline */}
                  <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                    <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
                      <h4 className="text-base font-semibold text-gray-900 flex items-center">
                        <FiCalendar className="mr-2 text-blue-600" />
                        Timeline
                      </h4>
                    </div>
                    <div className="p-4 space-y-3">
                      <div className="flex items-start space-x-2">
                        <div className={`w-2 h-2 rounded-full mt-1.5 ${selectedCheckin.status === 'booked' ? 'bg-yellow-600' : 'bg-blue-600'}`}></div>
                        <div>
                          <p className="text-xs font-semibold text-gray-900">
                            {selectedCheckin.status === 'booked' ? 'Expected Check-in' : 'Check-in'}
                          </p>
                          <p className="text-xs text-gray-600">
                            {new Date(selectedCheckin.checkinDateTime).toLocaleString()}
                          </p>
                        </div>
                      </div>
                      
                      <div className="flex items-start space-x-2">
                        <div className="w-2 h-2 bg-green-600 rounded-full mt-1.5"></div>
                        <div>
                          <p className="text-xs font-semibold text-gray-900">Expected Checkout</p>
                          <p className="text-xs text-gray-600">
                            {new Date(selectedCheckin.expectedCheckoutDateTime).toLocaleString()}
                          </p>
                        </div>
                      </div>
                      
                      {selectedCheckin.actualCheckoutDateTime && (
                        <div className="flex items-start space-x-2">
                          <div className="w-2 h-2 bg-purple-600 rounded-full mt-1.5"></div>
                          <div>
                            <p className="text-xs font-semibold text-gray-900">Actual Checkout</p>
                            <p className="text-xs text-gray-600">
                              {new Date(selectedCheckin.actualCheckoutDateTime).toLocaleString()}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional Info */}
              {(selectedCheckin.specialRequests || selectedCheckin.notes) && (
                <div className="mt-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
                  <div className="px-4 py-3 border-b border-blue-200">
                    <h4 className="text-base font-semibold text-gray-900 flex items-center">
                      <FiFileText className="mr-2 text-blue-600" />
                      Additional Information
                    </h4>
                  </div>
                  <div className="p-4 space-y-3">
                    {selectedCheckin.specialRequests && (
                      <div>
                        <p className="text-sm font-semibold text-gray-700 mb-1">Special Requests</p>
                        <p className="text-sm text-gray-900 bg-white p-3 rounded border border-blue-200">
                          {selectedCheckin.specialRequests}
                        </p>
                      </div>
                    )}
                    {selectedCheckin.notes && (
                      <div>
                        <p className="text-sm font-semibold text-gray-700 mb-1">Notes</p>
                        <p className="text-sm text-gray-900 bg-white p-3 rounded border border-blue-200">
                          {selectedCheckin.notes}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Footer */}
              <div className="mt-6 flex justify-end">
                <button
                  onClick={() => {
                    setShowDetailsModal(false);
                    setSelectedCheckin(null);
                  }}
                  className="px-6 py-2 bg-gradient-to-r from-gray-600 to-gray-700 text-white font-semibold rounded-lg hover:from-gray-700 hover:to-gray-800 transition-all duration-200"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cancel Booking Modal */}
      {showCancelBookingModal && selectedCheckin && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900">Cancel Booking</h3>
                <button
                  onClick={() => {
                    setShowCancelBookingModal(false);
                    setSelectedCheckin(null);
                    setCancelBookingData({ remark: '', refundableAmount: 0 });
                  }}
                  className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
                >
                  ×
                </button>
              </div>

              <div className="mb-4">
                <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
                  <p className="text-sm text-red-800">
                    <strong>Booking Details:</strong>
                  </p>
                  <p className="text-sm text-red-700 mt-1">
                    Check-in ID: {selectedCheckin.checkinId}
                  </p>
                  <p className="text-sm text-red-700">
                    Guest: {selectedCheckin.persons?.[0]?.name}
                  </p>
                  <p className="text-sm text-red-700">
                    Room: {selectedCheckin.roomId?.roomNumber}
                  </p>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Refundable Amount
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">₹</span>
                  <input
                    type="number"
                    className="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                    placeholder="Enter refundable amount"
                    value={cancelBookingData.refundableAmount}
                    onChange={(e) => setCancelBookingData({
                      ...cancelBookingData,
                      refundableAmount: parseFloat(e.target.value) || 0
                    })}
                    min="0"
                    step="0.01"
                  />
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Amount already paid: ₹{(selectedCheckin.pricing.paidAmount || 0).toFixed(2)}
                </p>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Remark <span className="text-red-500">*</span>
                </label>
                <textarea
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                  rows="3"
                  placeholder="Enter reason for cancellation..."
                  value={cancelBookingData.remark}
                  onChange={(e) => setCancelBookingData({
                    ...cancelBookingData,
                    remark: e.target.value
                  })}
                  required
                />
              </div>

              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => {
                    setShowCancelBookingModal(false);
                    setSelectedCheckin(null);
                    setCancelBookingData({ remark: '', refundableAmount: 0 });
                  }}
                  className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmCancelBooking}
                  disabled={!cancelBookingData.remark.trim()}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Confirm Cancellation
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {
        showEditModal &&
        <EditBookingModal
          showEditModal={showEditModal}
          setShowEditModal={setShowEditModal}
          bookingId={selectedCheckin?._id}
        />
      }

      
    </div>
  );
};

export default CheckinManagement;
